import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/Layout.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'layout',
      component: Layout,
      children: [
        { path: '', name: 'home', component: () => import('./views/Home.vue') },
        {
          path: 'detail',
          name: 'detail',
          component: () => import('./views/Detail.vue')
        },
        {
          path: 'pay/',
          name: 'pay-layout',
          component: () => import('./views/pay/index.vue'),
          children: [
            {
              path: '',
              name: 'pay',
              component: () => import('./views/pay/scan.vue')
            },
            {
              path: 'pay-ok',
              component: () => import('./views/pay/payOk.vue')
            },
            {
              path: 'pay-lose',
              component: () => import('./views/pay/payLose.vue')
            }
          ]
        },
        {
          path: '/my-center',
          name: 'my-center',
          component: () => import('./views/my-center/index.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login/index.vue'),
      children: [
        { path: '', component: () => import('./views/login/signIn.vue') },
        {
          path: 'sign-up',
          component: () => import('./views/login/signUp.vue')
        },
        {
          path: 'qr-sign-in',
          component: () => import('./views/login/qrSignIn.vue')
        },
        {
          path: 'find-pwd',
          component: () => import('./views/login/findPwd.vue')
        },
        {
          path: 'find-pwd-next',
          component: () => import('./views/login/findPwdNext.vue')
        },
        {
          path: 'find-pwd-ok',
          component: () => import('./views/login/findPwdOk.vue')
        },
        {
          path: 'bind-phone',
          component: () => import('./views/login/bindPhone.vue')
        }
      ]
    },
    {
      path: '/404',
      component: () => import('@/views/404.vue')
    },
    { path: '*', redirect: '/404' }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})
